module.exports = __webpack_public_path__ + "static/media/removablemedia.5e07a99b.png";